
var GranularApp = (function (window, undefined) {

    var $ = jQuery;

    var fire;
    fire = function () {

        var ctrl = false;
        var mediaQuery = window.matchMedia('(max-width: 768px)');
        jQuery(document).foundation();

        Menu.init();

        Bar.init();
        Bar.set(0.10);
        Bar.move(700);
        Bar.stop(1000);

        LazyLoad.init();


        jQuery('.carousel').owlCarousel({
            loop: false,
            nav: true,
            margin: 0,
            lazyLoad: true,
            autoplay: true,
            autoplayTimeout: 7000,
            autoplayHoverPause: true,
            smartSpeed: 700,
            navText: [
                '<i class="icon-angle_left" aria-hidden="true"></i>',
                '<i class="icon-angle_right" aria-hidden="true"></i>'
            ],
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 1
                },
                1000: {
                    items: 1
                }
            }
        });

        jQuery('select:not(.autocomplete)').select2();

        jQuery('select.autocomplete').select2({
            ajax: {
                delay: 250,
                cache: true,
                data: function (params) {
                    var query = {
                        search: params.term,
                        page: params.page
                    }
                    return query;
                },
                processResults: function (data) {
                    return {
                        results: data
                    };
                }
            }
        });

        jQuery('.match-height').matchHeight({
            byRow: false,
            property: 'height',
            target: null,
            remove: false
        });

        jQuery('.image-single').magnificPopup({
            type: 'image'
        });

        jQuery('.image-group').magnificPopup({
            delegate: 'a',
            type: 'image',
            mainClass: 'mfp-with-zoom',
            gallery: {
                enabled: true
            },
            zoom: {
                enabled: false,
                duration: 300,
                easing: 'ease-in-out',
                opener: function(openerElement) {

                }
            }
        });

        jQuery('[data-toggle="datepicker"]').datepicker({
            format: 'yyyy-mm-dd',
            language: 'en-GB',
            startDate: new Date(),
            startView: 0,
            autoHide: true,
            autoPick: true,
        });

        jQuery('.tooltip').tooltipster({
            theme: 'tooltipster-noir'
        });

        jQuery('.js-numstepper').numStepper({
            'minValue': 0,
            'maxValue': 18
        });

        jQuery(document).on('click', '.fadeout', (function (e) {
            var url = jQuery(this).attr('href');
            var target = jQuery(this).attr('target');
            if (url !== '#' &&
                url !== '#search-overlay' &&
                url !== '' &&
                url !== 'undefined' &&
                url.indexOf('tel:') == -1 &&
                url.indexOf('callto:') == -1 &&
                url.indexOf('mailto:') == -1 &&
                target !== '_blank' &&
                !isMobile() &&
                ctrl === false
            ) {
                jQuery('.body-content').animate({'opacity': 0}, 300);
                jQuery('.body-overlay').fadeIn('fast');
            }
        }));

        jQuery(document).on('click', '.search-overlay__open', (function (e) {
            e.preventDefault();
            var target = jQuery(this).attr('href');
            jQuery(target).fadeIn();
            console.log(target);
        }));

        jQuery(document).on('click', '.search-overlay-phone__open', (function (e) {
            e.preventDefault();
            var target = jQuery(this).find('a').attr('href');
            jQuery(target).fadeIn();
            console.log(target);
        }));

        jQuery(document).on('click', '.search-overlay__close', (function (e) {
            e.preventDefault();
            var target = jQuery(this).attr('href');
            jQuery(target).fadeOut();
        }));

        jQuery(document).on('click', '.more-expand__button', (function (e) {
            e.preventDefault();
            var target = jQuery(this).parent('.more-expand');

                        if (target.hasClass('open')) {
                target.removeClass('open');
            } else {
                target.addClass('open');
            }

                        console.log(target);
        }));

        jQuery('.accommodation-filter button[type="submit"]').click((function (e) {
            e.preventDefault();
            jQuery('.body-content').animate({'opacity': 0}, 300);
            jQuery('.body-overlay').fadeIn();
            jQuery('.accommodation-filter').submit();
            console.log('submit');
        }));

        jQuery('.accommodation-filter input[type="checkbox"]').change((function (e) {
            e.preventDefault();
            jQuery('.body-content').animate({'opacity': 0}, 300);
            jQuery('.body-overlay').fadeIn();
            jQuery('.accommodation-filter').submit();
        }));

        jQuery('.filter--autoreload select').change((function (e) {
            e.preventDefault();
            jQuery('.body-content').animate({'opacity': 0}, 300);
            jQuery('.body-overlay').fadeIn();
            jQuery(this).closest('form').submit();
        }));

        jQuery('.article-filter select').change((function (e) {
            e.preventDefault();
            var value = jQuery(this).val();
            var url = jQuery(this).closest('form').attr('action');
            if (value > 0 || value !== undefined || value !== null) {
                jQuery('.body-content').animate({'opacity': 0}, 300);
                jQuery('.body-overlay').fadeIn();
                jQuery('.article-filter').submit();
            } else {
                jQuery('.body-content').animate({'opacity': 0}, 300);
                jQuery('.body-overlay').fadeIn();
                window.location.href = url;
            }
        }));

        jQuery('.search--cottage form').submit((function (e) {
            e.preventDefault();
            var url = jQuery(this).attr('action');
            var country = jQuery('.search--cottage select[name="country"]').val();
            var adult = jQuery('.search--cottage select[name="adult"]').val();
            var child = 0;
            var infant = 0;
            var pets = 0;
            var start = jQuery('.search--cottage input[name="start"]').val();
            var end = jQuery('.search--cottage input[name="end"]').val();
            var nights = 7;
            var range = 3;
            var features = [];
            jQuery('.search--cottage input:checkbox[name=features]:checked').each((function() {
                features.push(jQuery(this).val());
            }));

            if (country != '') {
                url = url + '/' + country;
            }
            if (adult != '') {
                url = url + '?adult=' + adult;
                url = url + '&child=' + child;
                url = url + '&infant=' + infant;
                url = url + '&pets=' + pets;
            }
            if (start != '') {
                url = url + '&start=' + start;
                url = url + '&nights=' + nights;
                url = url + '&range=' + range;
            }
            if (features != '') {
                url = url + '&features=' + features.join();
            }
            var win = window.open(url, '_blank');
            win.focus();
        }));

        jQuery('.search-cottage-button').click((function (e) {
            e.preventDefault();
            var url = jQuery(this).attr('href');
            var country = jQuery('.search--accommodation select[name="location"]').val();
            var adult = jQuery('.search--accommodation select[name="guests"]').val();
            var child = 0;
            var infant = 0;
            var pets = 0;
            var now = new Date();
            var day = ('0' + now.getDate()).slice(-2);
            var month = ('0' + (now.getMonth() + 1)).slice(-2);
            var today = now.getFullYear() + '-' + (month) + '-' + (day);
            var nights = 7;
            var range = 3;
            var features = [];
            jQuery('.search--accommodation input:checkbox[name=features]:checked').each((function() {
                features.push(jQuery(this).val());
            }));

            if (country != '') {
                url = url + '/' + country;
            }
            if (adult != '') {
                url = url + '?adult=' + adult;
                url = url + '&child=' + child;
                url = url + '&infant=' + infant;
                url = url + '&pets=' + pets;
            }
            if (today != '') {
                url = url + '&start=' + today;
                url = url + '&nights=' + nights;
                url = url + '&range=' + range;
            }
            if (features != '') {
                url = url + '&features=' + features.join();
            }
            var win = window.open(url, '_blank');
            win.focus();
        }));

        jQuery('.search--cottage-alt .cottage-search__button').click((function (e) {
            e.preventDefault();
            console.log(e);
            var form = jQuery(this).closest('form');
            var url = jQuery(form).attr('action');
            var country = jQuery('.search--cottage-alt select[name="location"]').val();
            var adult = jQuery('.search--cottage-alt input[name="adult"]').val();
            var child = 0;
            var infant = 0;
            var pets = 0;
            var start = jQuery('.search--cottage-alt input[name="start"]').val();
            var end = jQuery('.search--cottage-alt input[name="end"]').val();

                        var nights = 7;
            var range = 3;
            var features = [];

            var date_start = new Date(start);
            var date_end = new Date(end);

            var time_difference = Math.abs(date_end.getTime() - date_start.getTime());
            var days_difference = Math.floor(time_difference / (1000 * 3600 * 24));
            nights = days_difference;


            jQuery('.search--cottage-alt input:checkbox[name=features]:checked').each((function() {
                features.push(jQuery(this).val());
            }));

            if (url === '') {
                return false;
            }

            if (country != '') {
                url = url + '/' + country;
            }
            if (adult != '') {
                url = url + '?adult=' + adult;
                url = url + '&child=' + child;
                url = url + '&infant=' + infant;
                url = url + '&pets=' + pets;
            }
            if (start != '') {
                url = url + '&start=' + start;
                url = url + '&nights=' + nights;
                url = url + '&range=' + range;
            }
            if (features != '') {
                url = url + '&features=' + features.join();
            }

            var win = window.open(url, '_blank');
            win.focus();
        }));

        jQuery('.newsletter__form form').submit((function (e) {
            e.preventDefault();
            var endpoint = jQuery(this).attr('action');
            var email = jQuery('.newsletter__form form input[type=email]').val();

                        if (!isEmail(email)) {
                jQuery('.newsletter__form__status').text('Please enter valid email address!');
                return;
            }

            jQuery.ajax({
                type: 'GET',
                url: endpoint,
                dataType: 'json',
                data: {'email': email},
                beforeSend: function() {

                },
                success: function(result) {
                    if (result.status) {
                        jQuery.event.trigger({
                            type: 'newsletter.subscribed',
                            message: result.message,
                        });
                        jQuery('.newsletter__form__status').text(result.message);
                        jQuery('.newsletter__form form input[type=email]').val('');
                    } else {
                        jQuery('.newsletter__form__status').text(result.message);
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                }
            });
        }));

        jQuery('#filter-properties').on('change.numstep', '.js-numstepper', (function(event, mode, value, valueOld) {
            jQuery('.search--cottage-alt input[name="adult"]').val(value);
            setTimeout((function() {
                jQuery('#filter-properties').submit();
            }), 1000);
        }));

        jQuery('#filter-properties').find('input, select, mouseup, keyup').on('change', (function(event) {
            setTimeout((function() {
                jQuery('#filter-properties').submit();
            }), 1000);
        }));

        jQuery('.filter-sidebar__close').on('click', (function(event) {
            event.preventDefault();
            var filterGroup = this.closest('.filter-sidebar__filter');

            if (jQuery(filterGroup).hasClass('open')) {
                jQuery(filterGroup).removeClass('open');
            } else {
                jQuery(filterGroup).addClass('open');
            }
        }));

        jQuery('.filter-status__link').on('click', (function(event) {
            event.preventDefault();
            var layout = jQuery(this).data('layout');

            jQuery('.layout-view').removeClass('open');
            jQuery('.filter-status__link').removeClass('active');
            jQuery('#' + layout).addClass('open');
            jQuery(this).addClass('active');
        }));

        jQuery('.filter-status__button--filters').on('click', (function(event) {
            var filters = jQuery('.property-list__filters');

            if (filters.hasClass('open')) {
                filters.removeClass('open');
            } else {
                filters.addClass('open');
            }
        }));

        jQuery('.filter-status__button--layout').on('click', (function(event) {
            event.preventDefault();

            if (jQuery(this).hasClass('filter-status__button--layout--map')) {
                jQuery(this).removeClass('filter-status__button--layout--map');
                jQuery(this).addClass('filter-status__button--layout--list');
                jQuery(this).text('List view');

                                jQuery('.layout-view').removeClass('open');
                jQuery('#view-map').addClass('open');
            } else if (jQuery(this).hasClass('filter-status__button--layout--list')) {
                jQuery(this).removeClass('filter-status__button--layout--list');
                jQuery(this).addClass('filter-status__button--layout--map');
                jQuery(this).text('Map view');

                                jQuery('.layout-view').removeClass('open');
                jQuery('#view-list').addClass('open');
            }
        }));

        jQuery('.sharing').on('click', (function(event) {
            var sharing = jQuery('.sharing');
            console.log(sharing);

            if (sharing.hasClass('open')) {
                sharing.removeClass('open');
            } else {
                sharing.addClass('open');
            }
        }));

        jQuery('.selected-tag').click((function (event) {
            event.preventDefault();
            var form = jQuery(this).closest('form');
            var category = jQuery(this).data('filter-category');
            var term = jQuery(this).data('filter-term');

            if (category === 'types') {
                return false;
            }

            if (category === 'features' || category === 'ages') {
                jQuery('[data-category="' + category + '"][data-term="' + term + '"]').prop('checked', false);
            }

            if (category === 'locations') {
                jQuery('[data-category="' + category + '"]').val('').change();
            }

            if (category === 'guests') {
                jQuery('[data-category="' + category + '"]').val('')
            }

            jQuery(this).remove();
            jQuery(form).submit();
        }));


        jQuery(document).keydown((function(event){
            if (event.which == '17') {
                ctrl = true;
            }
        }));

        jQuery(document).keyup((function(event){
            ctrl = false;
        }));

        handleWindowsResize(mediaQuery);
        mediaQuery.addListener(handleWindowsResize);

        jQuery('.body-overlay').fadeOut('fast');
        jQuery('.body-content').animate({'opacity': 1}, 500);

    }; 

    var unload = function () {


    };

    var resize = function () {



    };

    var scroll = function () {

    };

    var handleWindowsResize = function(mediaQuery) {
        if (mediaQuery.matches) {
            jQuery('.filter-sidebar__filter').removeClass('open');
        }
    }

    var isEmail = function(email) {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    return {
        fire: fire,
        unload: unload,
        resize: resize,
        scroll: scroll
    };
})( window );


document.addEventListener("DOMContentLoaded", (function () {
    GranularApp.fire();
}));

window.addEventListener('unload', (function () {
    GranularApp.unload();
}));

window.addEventListener('resize', (function () {
    GranularApp.resize();
}));

window.addEventListener('wheel', (function () {
    GranularApp.scroll();
}));

